import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../../colors';

export const useStyles = makeStyles({
  root: {
    '& > .MuiPaper-root': {
      marginTop: 8,
      borderRadius: 6,
      boxShadow: '0px 10px 20px rgb(0 0 0 / 10%)',
      '& > .MuiList-root': {
        padding: 16,
      },
    },
  },
  options: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    '& .MuiFormControlLabel-label': {
      fontSize: 14,
      fontWeight: 600,
    },
  },
  optionItem: {
    padding: 0,
    fontFamily: 'Manrope',
    fontWeight: 600,
    fontSize: 14,
    textAlign: 'left',
    letterSpacing: '0.01em',
    color: colors.textPrimary,
  },
  allOptionItem: {
    color: colors.textHighContrast,
  },
  filterBtn: {
    fontSize: 16,
    fontWeight: 'bold',
    color: colors.primary600,
    border: `1px solid ${colors.primary300}`,
    height: 48,
    minWidth: 144,
    width: 'auto',
    background: '#FFF',
    padding: '12px 20px',
    borderRadius: 6,
    letterSpacing: 0,
  },
  filterBtnDisabled: {
    opacity: 0.7,
    border: 'none !important',
  },
  appliedCount: {
    '& > div': {
      width: 24,
      minWidth: 24,
      height: 24,
      fontSize: 12,
      fontWeight: 'bold',
    },
    '& > p': {
      marginLeft: 8,
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
    },
  },
});
